import React from 'react';

function AddressTab({ form, handleChange, handlePincodeBlur, handleAccountNameBlur, accountExists, handleFetchGstData }) {
  return (
    <>
      <div className="mb-3">
        <label className="form-label">GST No.</label>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            name="gst_no"
            value={form.gst_no}
            onChange={handleChange}
            placeholder="Enter GST number"
            autoComplete="off"
          />
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={handleFetchGstData}
          >
            Fill Data
          </button>
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="account_name" className="form-label">Account Name</label>
        <input
          type="text"
          className={`form-control ${accountExists ? 'is-invalid' : ''}`}
          id="account_name"
          name="account_name"
          value={form.account_name}
          onChange={handleChange}
          onBlur={handleAccountNameBlur}
          required
          autoComplete="off"
        />
        {accountExists && <div className="invalid-feedback">Account name already exists</div>}
      </div>

      <div className="mb-3">
        <label htmlFor="address" className="form-label">Billing Address</label>
        <textarea
          className="form-control"
          id="address"
          name="address"
          value={form.address}
          onChange={handleChange}
          rows={3}
          autoComplete="off"
        ></textarea>
      </div>

      <div className="row">
        <div className="col-md-4 mb-3">
          <label htmlFor="pincode" className="form-label">Pincode</label>
          <input
            type="text"
            className="form-control"
            id="pincode"
            name="pincode"
            value={form.pincode}
            onChange={handleChange}
            onBlur={handlePincodeBlur}
            autoComplete="off"
          />
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="city" className="form-label">City</label>
          <input
            type="text"
            className="form-control"
            id="city"
            name="city"
            value={form.city}
            onChange={handleChange}
            autoComplete="off"
          />
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="state" className="form-label">State</label>
          <input
            type="text"
            className="form-control"
            id="state"
            name="state"
            value={form.state}
            onChange={handleChange}
            autoComplete="off"
          />
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="country" className="form-label">Country</label>
        <input
          type="text"
          className="form-control"
          id="country"
          name="country"
          value={form.country}
          onChange={handleChange}
          autoComplete="off"
        />
      </div>
    </>
  );
}

export default AddressTab;
